// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled

import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

export const isTwpBenefitsModalOpen = (state: State) =>
	state.ui.TwpBenefitsModal.isTwpBenefitsModalOpen;
